import { useTranslation } from 'react-i18next';

import type { ChatMessage } from '@/signalr';
import { humanizeDate } from '@/lib/time';

export type DispatcherMessageComponentProps = {
  message: ChatMessage;
  onImageClick: (url: string) => void;
};

export function DispatcherMessageComponent({ message, onImageClick }: DispatcherMessageComponentProps) {
  const { i18n } = useTranslation();
  const attachedImageUrl = message.attachedImageUrl;

  return (
    <div className="col-9 offset-3 p-1 rounded-top-3 rounded-start-3 bg-chat-dispatcher">
      <div className="x-small text-muted">{humanizeDate(message.sentTimeUtc, i18n.language || 'en')}</div>

      {message.message != null && <div>{message.message}</div>}

      {attachedImageUrl != null && (
        <div className="mt-1 cursor-zoom-in" onClick={() => onImageClick(attachedImageUrl)}>
          <img src={attachedImageUrl} className="img-fluid rounded-3 bg-dark-subtle" alt="Attached image" />
        </div>
      )}
    </div>
  );
}
